module.exports = __webpack_public_path__ + "media/assets/images/blog/WhatsApp-AmazonConnect-edb407fcaccf6bd6a35139794e79f120.jpeg";